import React from 'react';
import { DataList } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import { columnConfigs, DEFAULT_CONFIG } from './listConfig';

const TransactionHistoryList: React.FC<{ getTransactionData: (props: any) => any; globalForceUpdate: boolean }> = ({
	getTransactionData,
	globalForceUpdate
}) => {
	return (
		<DataList
			fetchData={getTransactionData}
			defaults={DEFAULT_CONFIG}
			columnConfigs={columnConfigs}
			hideActions
			entity={LIST_ENTITY_NAMES.TRANSACTIONHISTORY}
			globalForceUpdate={globalForceUpdate}
			height='calc(100vh - 220px)'
		/>
	);
};

export default TransactionHistoryList;
